<template>
<div>
  <div id="herovoice">
    <div id="controlBar">
      <div class="switcher">
        <input type="checkbox" id="toggle" v-model="controlBar.showFilename">
        <label for="toggle">
          <span v-if="controlBar.showFilename">显示文件名</span>
          <span v-else>隐藏文件名</span>
        </label>
      </div>
    </div>
      <div class="titleBoard">
        <div class="left" @click="sideChange(0)">
          <p class="name" :class="{active:!currentSide}">{{twins[0].name}}</p>
          <p class="lang" @click.stop="toggleLanguage(0)" title="切换语言">{{languageIconFont(0)}}</p>
          <p class="contributor" title="本内容维护者">{{twins[0].contributor||"kaikaiiiiiii"}}</p>
        </div>
        <div class="right" @click="sideChange(1)">
          <p class="name" :class="{active:currentSide}">{{twins[1].name}}</p>
          <p class="lang" @click.stop="toggleLanguage(1)" title="切换语言">{{languageIconFont(1)}}</p>
          <p class="contributor" title="本内容维护者">{{twins[1].contributor||"kaikaiiiiiii"}}</p>
        </div>
      </div>
      <div class="vo-list">
        <div class="voCategory" v-for="(cate,index) in voGroupsShow" :key="index">
          <p class="catename">{{cate.name}}</p>
          <div class="label" v-for="(label,index) in cate.labels" :key="index">
            <div class="left">
              <p class="labelName">{{label.name}}</p>
              <div class="labellist">
                <soundPlay v-for="item in label.leftVOs" :key="item.filename" :vo="item" :lang="languages[0]" :side="0"
                 @play="playSound" @download="downloadSound(item,languages[0])" :showname="controlBar.showFilename"></soundPlay>
              </div>
            </div>
            <div class="right">
              <p class="labelName">{{label.name}}</p>
              <div class="labellist">
                <soundPlay v-for="item in label.rightVOs" :key="item.filename" :vo="item" :lang="languages[1]" :side="1"
                @play="playSound" @download="downloadSound(item,languages[1])" :showname="controlBar.showFilename"></soundPlay>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>
</template>

<script>
import papa from 'papaparse';
import {heroVOCates,
        heroVOLabels,
        announcerVOCates,
        announcerVOLabels} from './data.js'
import soundPlay from './soundPlay.vue'
import audio5 from 'audio5';
const a5js = new audio5({});
import downfile from 'djs';

export default {
  components:{soundPlay},
  props: ['twins','currentSide','listType'],
  data(){
    return {
      leftList: [],
      rightList: [],
      voGroupsShow: [],
      languages: ["cn","cn"],
      heroListCates:heroVOCates,
      heroListLabels:heroVOLabels,
      announcerListCates:announcerVOCates,
      announcerListLabels:announcerVOLabels,
      controlBar: {showFilename:false},
    }
  },
  computed: {
    cates () {
      switch (this.listType){
        case "hero":      return this.heroListCates;      break;
        case "announcer": return this.announcerListCates; break;
        case "map":       return this.announcerListCates; break;
      }
    },
    labels () {
      switch (this.listType){
        case "hero":        return this.heroListLabels;       break;
        case "announcer":   return this.announcerListLabels;  break;
        case "map":         return this.announcerListLabels;  break;
        }
    },
    voList(){
      /* vo: {
        pID:[100],cn:1,en:1,ext:"ogg",filename:"AbathurHero_AI_Attack00",
        textCN:"进攻机会。",textEN:"Attack opportunity.",categoryID:11,labelID:10
        side:0,libID:100,urlCN:"https://......",urlEN:"https://......"
        }
      */
      let result = this.leftList.concat(this.rightList);
      /* 插入各种筛选器 */
      //某些文件只有 en 文件，另一些只在 cn 出现。
      result = result.filter(e=>{
        return e[this.languages[e.side]];
      });
      return result;
    },
    voGroupsData(){
      //先建立一个稀疏的二维空对象数组，填充完毕后清理空格
      let result = [];
      for (let i = 0; i<=100;i++){
        result[i] = {name:"", order: 100, count: 0, labels:[]};
        for (let j = 0; j<=100;j++){
          result[i].labels[j] = {name:"", count: 0, leftVOs:[], rightVOs:[]};
        };
      };
      this.cates.forEach((c,index)=>{
        let thiscate = result[c.ID];
        thiscate.name = c.name;
        thiscate.order = index;
        this.labels.forEach(label=>{
          let thislabel = thiscate.labels[label.ID];
          thislabel.name = label.name;
        });
      });
      this.voList.forEach(e=>{      //将 vo 填充入该二维数组
        let x = e.categoryID||99;  //data.js 定义未分类 cateid 为 99
        let y = e.labelID||99;     //data.js 定义未分类 labelid 为 99
        if(e.side==0){
          result[x].labels[y].leftVOs.push(e);
        }else{
          result[x].labels[y].rightVOs.push(e);
        }
        result[x].count           += 1;
        result[x].labels[y].count += 1;
      });
      result = result.filter(cate=>{return cate.count>0}); //clean empty cate
      result.forEach(cate=>{//clean empty label if cate is not empty
        cate.labels=cate.labels.filter(label=>{
          return label.count>0
          });
      });
      result.sort((a,b)=>{return a.order-b.order});
      return result;
    }
  },
  methods:{
    languageIconFont(lang){
      if(this.languages[lang]=="cn"){return "中文"}
      if(this.languages[lang]=="en"){return "英文"}
      return false;
    },
    voGroupsShowElementNumberIncrease(){
      /* 音频列表元素太多一次性加载所有 DOM 会卡页面，延时加载 */
      var me = this;
      var i = 0;
      var end = this.voGroupsData.length;
      me.voGroupsShow = [];
      function increase() {
        setTimeout(function (){
          if(i < end){
            me.voGroupsShow.push(me.voGroupsData[i]);
            i++;
            increase();
          }
        }, 100);
      }
      increase();
    },
    sideChange(item){
      this.$emit('sideChanged',item);
    },
    playSound(playURL){
      a5js.one("canplay",function () {a5js.play()},a5js);
      a5js.load(playURL);
    },
    downloadSound(item,lang){
      var downURL = lang == "cn" ? item.urlCN : item.urlEN;
      if(window.adblock===undefined){
        console.log("Adblock disabled the cross-domain download request. Open new tab to visit the sound file directly.")
        window.open(downURL, '_blank');
      }else{
        downfile(downURL);
      }
    },
    toggleLanguage(s){
      if (this.languages[s]=="cn"){
        this.$set(this.languages,s,"en");
      }else{
        this.$set(this.languages,s,"cn");
      }
    },
    
  },
  watch:{
    twins: function(){
      const me = this;
      this.voGroupsLoadedElementNumber = 1;
      //加载左列表
      var sheetsnumber = this.twins[0].pID.length + this.twins[1].pID.length;
      var donecount = 0;
      var leftTemp = [];
      var rightTemp = [];
      this.twins[0].pID.forEach(prefixID => {
        var sheetpath = "/static/sheets/"+prefixID+".csv"
        papa.parse(sheetpath,{
          download: true,
          header: true,
          dynamicTyping: true,
          encoding: "UTF-8",
          complete: function(result){
            result.data.forEach(e => {
              e.urlCN = "https://vo.kaikai.info/p"+e.pID+"/cn/"+encodeURIComponent(e.filename)+"."+e.ext;
              e.playCN = "https://vo.kaikai.info/p"+e.pID+"/cn/"+encodeURIComponent(e.filename)+".mp3";
              e.urlEN = "https://vo.kaikai.info/p"+e.pID+"/en/"+encodeURIComponent(e.filename)+"."+e.ext;
              e.playEN = "https://vo.kaikai.info/p"+e.pID+"/en/"+encodeURIComponent(e.filename)+".mp3";
              e.libID = me.twins[0].libID;
              e.side = 0;
            });
            leftTemp = leftTemp.concat(result.data);
            donecount += 1;
            if (donecount == sheetsnumber){
              me.leftList = leftTemp;
              me.rightList = rightTemp;
              me.voGroupsShowElementNumberIncrease();
            }
          }
        });
      });
      //加载右列表
      this.twins[1].pID.forEach(prefixID => {
        var sheetpath = "/static/sheets/"+prefixID+".csv"
        papa.parse(sheetpath,{
          download: true,
          header: true,
          dynamicTyping: true,
          encoding: "UTF-8",
          complete: function(result){
            result.data.forEach(e => {
              e.urlCN = "https://vo.kaikai.info/p"+e.pID+"/cn/"+encodeURIComponent(e.filename)+"."+e.ext;
              e.playCN = "https://vo.kaikai.info/p"+e.pID+"/cn/"+encodeURIComponent(e.filename)+".mp3";
              e.urlEN = "https://vo.kaikai.info/p"+e.pID+"/en/"+encodeURIComponent(e.filename)+"."+e.ext;
              e.playEN = "https://vo.kaikai.info/p"+e.pID+"/en/"+encodeURIComponent(e.filename)+".mp3";
              e.libID = me.twins[1].libID;
              e.side = 1;
            });
            rightTemp = rightTemp.concat(result.data);
            donecount += 1;
            if (donecount == sheetsnumber){
              me.leftList = leftTemp;
              me.rightList = rightTemp;
              me.voGroupsShowElementNumberIncrease();
            }
          }
        });
      });
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
#herovoice{
  background: rgba(255, 255, 255, 0.25);
}
#controlBar{
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  position: relative;
  user-select: none;
  padding: 4px;
  .switcher{
    display: flex;
    justify-content: space-around;
  }
  #toggle{
    height: 0;
    width: 0;
    visibility: hidden;
    &:checked + label{
      background: rgba(0, 164, 230, 0.801);
    }
    &:checked + label:after{
      left: 36px;
      transform: translateX(-100%);
    }
  }
  label{
    cursor: pointer;
    text-indent: 45px;
    overflow: visible;
    white-space: nowrap;
    width: 40px;
    height: 22px;
    background: rgba(255, 51, 0, 0.6);
    display: block;
    border-radius: 20px;
    position: relative;
    &:after{
      content:"";
      position: absolute;
      top: 3px;
      left: 3px;
      width: 16px;
      height: 16px;
      background: #fff;
      border-radius: 8px;
      transition: 0.3s;
    }
    &:active:after{
      width: 33px;
      transition: 0.3s;
    }
  }
}
.titleBoard{
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  min-height: 120px;
  .left, .right{
    padding: 0 12px;
    display:flex;
    flex-direction: column;
    .name {
      cursor: pointer;
      align-self: center;
      font-size: 2.6em;
      font-weight: 500;
      margin: 12px 0;
    }
    .lang{
      margin: 12px 0;
      cursor: pointer;
      padding: 6px 10px;
      font-size: 1.6em;
      text-align: center;
      font-weight: 600;
      color: #fff;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 4px;
      &:hover{
        text-shadow: 0px 1px 1px rgba(255, 255, 255, 0.75),
              0px -1px 1px rgba(255, 255, 255, 0.75),
              1px 0px 1px rgba(255, 255, 255, 0.75),
              -1px 0px 1px rgba(255, 255, 255, 0.75);
      }
    }
    .contributor{
      font-style: italic;
      cursor: help;
    }
  }
  .left{
    align-items: flex-start;
    .name.active {
      text-shadow: 0px 1px 2px #77aaff,
      0px -1px 2px #77aaff,
      1px 0px 2px #77aaff,
      -1px 0px 2px #77aaff;
    }
  }
  .right{
    align-items: flex-end;
    .name.active {
      text-shadow: 0px 1px 2px #ff6f6f,
      0px -1px 2px #ff6f6f,
      1px 0px 2px #ff6f6f,
      -1px 0px 2px #ff6f6f;
    }
  }
}
.vo-list{
  color: #fff;
  display: flex;
  flex-direction: column;
  .label{
    display: flex;
    .labelName{
      display: inline-block;
      color:#fff;
      background:#333;
      padding:2px 8px;
      border-radius: 4px;
      text-align: left;
    }
    .labellist{
      display: flex;
      flex-wrap: wrap;
    }
  }
}
.left, .right{
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/listcompare.vue